import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

const ProcessController = ({handleSubmit,submitProcess,setSubmitProcess,locationPath,entity = 'Tour'}) => {
    const [loading,setLoading] = useState(false);
    const [note,setNote] = useState('')
    useEffect(()=>{
        switch (submitProcess){
            case 'created':
                setNote(`${entity} created successfully!`)
                setTimeout(()=>{window.location.href = locationPath},1000)
                break;
            case 'updated':
                setNote(`${entity} updated successfully!`)
                break;
            case 'error':
                setNote('Please fill in all fields')
                break;
            case 'load':
                setNote('loading ...')
                break;
            case 'error-text-length':
                setNote('Please check fields max length')
            break;
            default:
                break;
        }
        submitProcess === 'load' ? setLoading(true) : setLoading(false);
    },[submitProcess,entity,locationPath])
    return (
        <div className='process-controller'>
            <div className="d-flex">
                <button
                    onClick={()=>{ handleSubmit() }}
                    disabled={submitProcess === 'load'}
                    className='button-green mx-2'
                    style={{ opacity: submitProcess === 'load' ? 0.6 : 1, cursor: submitProcess === 'load' ? 'not-allowed' : 'pointer' }}
                >Save</button>
            </div>
            {submitProcess !== 'none' ?
                <div className={`notification ${submitProcess}`}>
                    <p>{note}</p>
                {submitProcess !== 'load' ? <div onClick={() => {
                    setSubmitProcess('none')
                }}
                      className="x-button">X
                </div> : ''}
            </div> : ''}
            <div className="loading-container">
                <Box sx={{ width: '100%' }}>
                    <LinearProgress value={0} variant={loading ? 'indeterminate' : 'determinate'}/>
                </Box>
            </div>

        </div>
    );
};

export default ProcessController;
